module.exports = __webpack_public_path__ + "static/media/bakingStationImg5.e95342c8.jpg";